<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Working Experience"
      text="Create working experiences"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="companyName"
                v-validate="'required'"
                outlined
                :error-messages="errors.collect('companyName')"
                data-vv-name="companyName"    
                data-vv-as="previous company"
                label="Previous Company"
                :class="{
                  'required':!companyName
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="occupation"
                outlined
                label="Occupation"
              />
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    v-validate="'required'"
                    :error-messages="errors.collect('startDateDisplay')" 
                    data-vv-name="startDateDisplay"
                    label="Start Date"
                    readonly
                    outlined
                    data-vv-as="start date"  
                    class="label-position"   
                    :class="{
                      'required':!startDateDisplay
                    }"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  type="month"
                  @input="startDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="6"
              class="pb-0"
            >
              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    v-validate="'required'"
                    label="End Date"
                    :error-messages="errors.collect('endDateDisplay')"
                    data-vv-name="endDateDisplay"  
                    data-vv-as="end date"  
                    readonly
                    outlined
                    class="label-position"
                    :class="{
                      'required':!endDateDisplay
                    }"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  type="month"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-textarea
                v-model="reason"
                v-validate="'required'"
                :error-messages="errors.collect('reason')"
                label="Reason of Leaving"
                auto-grow
                data-vv-name="reason"  
                outlined
                rows="3"
                row-height="25"
                :class="{
                  'required':!reason
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        reason: null,
        startDate: null,
        endDate: null,
        companyName: null,
        occupation: null,
        startDateMenu: false,
        endDateMenu: false,
      }
    },

    computed: {
      startDateDisplay () {
        return this.startDate ? this.$moment(this.startDate, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
      endDateDisplay () {
        return this.endDate ? this.$moment(this.endDate, 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        this.loading = true
      
        this.loading = false
      },
    },
    methods: { 
      prepareFormData () {
        return {
          company_name: this.companyName,
          start_date: this.startDate + '-01',
          end_date: this.endDate + '-01',
          reason: this.reason,
          occupation: this.occupation,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.hrisWorkingExperiences().create(this.employeeUid, this.prepareFormData())
              .then((response) => {
                if (response.status === 200 || response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false       
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}

.label-position >>> .v-label.v-label--active{
  margin-left:-28px
}
</style>
